import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { UsersService } from '../users-service.service';
import { catchError, of, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-user-record',
  templateUrl: './user-record.component.html',
  styleUrls: ['./user-record.component.less'],
})
export class UserRecordComponent extends BaseComponent implements OnInit {
  user: any;
  roles: any[] = [];
  constructor(injector: Injector, private usersService: UsersService) {
    super(injector);
  }

  ngOnInit() {
    this.subscriptions.push(
      this.usersService
        .getRoles()
        .pipe(
          tap((response) => {
            this.roles = response as any[];
          })
        )
        .subscribe()
    );
    this.subscriptions.push(
      this.route.params
        .pipe(
          switchMap((params) => {
            if (params['email'] == null) {
              this.notification.error('Error', 'No email exists in the route');
              this.router.navigate(['/management']);
              return of(false);
            } else return this.usersService.getUserByEmail(params['email']);
          }),
          tap((user) => {
            this.user = user;
          })
        )
        .subscribe()
    );
  }
  submitUser() {
    this.subscriptions.push(
      this.usersService.updateUser(this.user).subscribe(() => {
        this.message.success('User updated successfullt');
        this.router.navigate(['/management']);
      })
    );
  }

  onBack() {
    this.router.navigate(['/management'], { relativeTo: this.route });
  }
}
